// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_gYaTm{--rootPadding:0px}.grid_lQEr0{display:grid;grid-template-columns:1fr;grid-column-gap:0;-moz-column-gap:0;column-gap:0;grid-row-gap:18px;row-gap:18px;margin-top:18px}.gridItem_UMPMB{display:flex}@media only screen and (min-width:768px){.root_gYaTm{--rootPadding:0px 0px 15px}.grid_lQEr0{display:grid;grid-template-columns:1fr 1fr;grid-column-gap:18px;-moz-column-gap:18px;column-gap:18px;grid-row-gap:18px;row-gap:18px;margin-top:18px}}.root_gYaTm{margin:0 auto;max-width:900px;padding:var(--rootPadding)}.image_w436W{max-width:100%;max-height:100%}.image_w436W img{width:60px;height:60px}.description_iXaiR{margin-left:18px}.description_iXaiR a{color:#252525}", ""]);
// Exports
exports.locals = {
	"root": "root_gYaTm",
	"grid": "grid_lQEr0",
	"gridItem": "gridItem_UMPMB",
	"image": "image_w436W",
	"description": "description_iXaiR"
};
module.exports = exports;
